var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"text"},[_vm._v("GOOD-BYE 2018")]),_c('div',{staticClass:"bar"},[_c('div',{staticClass:"gage",style:(_vm.getPercent)})])])}
var staticRenderFns = []

export { render, staticRenderFns }